var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import axios from "./http.js";
import { _getLocale } from "../utils/locale";
const _VideosApi = class _VideosApi {
  // In-memory cache object
  static getVideos() {
    const abortController = new AbortController();
    return {
      async call(params = {}) {
        const locale = _getLocale();
        const endpoint = `/v2/Videos?${new URLSearchParams(params).toString()}`;
        const cacheKey = `${endpoint}|locale=${locale}`;
        if (_VideosApi.cache.has(cacheKey)) {
          return Promise.resolve(_VideosApi.cache.get(cacheKey));
        }
        return axios.get(endpoint, {
          signal: abortController.signal,
          params
        }).then((response) => {
          _VideosApi.cache.set(cacheKey, response);
          return response;
        });
      },
      cancel() {
        abortController == null ? void 0 : abortController.abort();
      }
    };
  }
};
__publicField(_VideosApi, "cache", /* @__PURE__ */ new Map());
let VideosApi = _VideosApi;
var stdin_default = VideosApi;
export {
  stdin_default as default
};
